import Vue from 'vue'
import Vuex from 'vuex';
import index from './modules/main/index.js';
import ucenter from './modules/main/ucenter.js';
import login from './modules/main/login.js';
import cart from './modules/main/cart.js';
import order from './modules/main/order.js';
import notification from './modules/main/notification.js';
import ucenter_order from "./modules/main/ucenter_order";
import shop_board from "./modules/main/shop_board";
import wxshopShop from "./modules/wxshop/shop.js";
import wxshopOrder from "./modules/wxshop/order.js";
import wxshopRelative from "./modules/wxshop/relative.js";
import wxshopPurchase from "./modules/wxshop/purchase.js";
import wxshopDelivery from "./modules/wxshop/delivery.js";
import linkImport from './modules/main/link_import.js';


Vue.use(Vuex);

let store = new Vuex.Store({
	modules: {
		index,
		ucenter,
		login,
		cart,
		order,
		notification,
		ucenter_order,
		shop_board,
		wxshopShop,
		wxshopOrder,
		wxshopRelative,
		wxshopPurchase,
		wxshopDelivery,
		linkImport
	}
});

export default store;
